// extracted by mini-css-extract-plugin
export default {"container":"User_container__on90t"};